import React                         from 'react';
import { useSelect }                 from '@wordpress/data';
import GuaranteeBadge                from '../../components/Badges/GuaranteeBadge';
import ReviewBadge                   from '../../components/Badges/ReviewBadge';
import TrustBadgeInterface           from '../../interfaces/TrustBadgeInterface';
import DataService                   from '../Services/DataService';
import DataStores                    from '../DataStores';

const TrustBadges: React.FC = () => {
    const badges = useSelect( ( select: any ) => select( DataStores.cart_store_key ).getTrustBadges(), [] );
    const row = DataService.getSetting( 'trust_badges_display' ) !== 'below_cart_summary';

    return (
        <div className={`flex mt-4 items-start ${row ? 'flex-row flex-wrap' : 'flex-col'}`}>
            {badges.map( ( badge: TrustBadgeInterface ) => {
                switch ( badge.template ) {
                    case 'guarantee':
                        return (
                            <GuaranteeBadge
                                key={badge.id}
                                title={badge.title}
                                description={badge.description}
                                imageUrl={badge.image?.url || undefined}
                            />
                        );
                    case 'review':
                        return (
                            <ReviewBadge
                                key={badge.id}
                                title={badge.title}
                                subtitle={badge.subtitle}
                                description={badge.description}
                                imageUrl={badge.image?.url || undefined}
                            />
                        );
                    default: return null;
                }
            } )}
        </div>
    );
};

export default TrustBadges;
